import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/login.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { environment } from '@env/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  imports: [CommonModule]
})
export class HeaderComponent implements OnInit {

  user$!: Observable<{
    username?: string;
    fullName?: string;
    email?: string;
    token?: string;
  } | null>;

  isDropdownOpen = false;

  readonly branding = environment.branding;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.user$ = this.authService.user$;
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  logout(): void {
    this.authService.signOut();
    this.isDropdownOpen = false;
  }

  login(): void {
    this.authService.signIn();
  }
}
